import type { CSSProperties, HTMLAttributes } from "react";
import regions from "../../../surfacekit/assets/rumonai/light-regions.json";

export type LightMotionState = "waiting" | "working" | "done";
export type LightMotionProps = HTMLAttributes<HTMLSpanElement> & {
  state?: LightMotionState;
  compact?: boolean;
};

const waterlight = new URL("../../../surfacekit/assets/rumonai/waterlight.webp", import.meta.url).href;

/** Decorative feedback follows the caller's real state; it never advances work. */
export function LightMotion({ state = "working", compact = false, className = "", ...props }: LightMotionProps) {
  return <span {...props} className={`paint-light${compact ? " compact" : ""} ${className}`.trim()} data-state={state} aria-hidden="true">
    <img className="reflection-ground" src={waterlight} alt="" draggable={false} />
    {regions.map((region, index) => <img key={index} className="reflection-dab" data-tone={region.tone}
      src={waterlight} alt="" draggable={false}
      style={{ clipPath: region.clip, "--phase": `${region.phase}s`, "--order": index } as CSSProperties} />)}
  </span>;
}
